import { connect } from 'react-redux';
import VerificationRequiredComponent from './VerificationRequiredComponent';
import { kycVerificationLevelsSelector } from '../../redux/selectors/kycLevelsSelectors';
import config from '../../config';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _kycVerificationLevel = kycVerificationLevelsSelector(state),
    disableTrading = _kycVerificationLevel.disableTrading,
    isUnderReview = _kycVerificationLevel.isUnderReview;
  return Object.assign({
    verificationRequired: true,
    verificationLevelPageUrl: config.KYC.verificationRequiredUrl,
    enableVerificationLinkOnClick: false,
    disabled: disableTrading,
    isUnderReview: isUnderReview
  }, ownProps);
};
var mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(VerificationRequiredComponent);